import type { SportType } from "@/types/data.types";

export const STRAVA_HEATMAP_SPORTS = new Set<SportType>([
  "AlpineSki",
  "BackcountrySki",
  "Badminton",
  "Canoeing",
  "EBikeRide",
  "EMountainBikeRide",
  "Golf",
  "GravelRide",
  "Handcycle",
  "Hike",
  "IceSkate",
  "InlineSkate",
  "Kayaking",
  "Kitesurf",
  "MountainBikeRide",
  "NordicSki",
  "Pickleball",
  "Ride",
  "RockClimbing",
  "RollerSki",
  "Rowing",
  "Run",
  "Sail",
  "Skateboard",
  "Snowboard",
  "Snowshoe",
  "Soccer",
  "StandUpPaddling",
  "Surfing",
  "Swim",
  "Tennis",
  "TrailRun",
  "Velomobile",
  "VirtualRide",
  "VirtualRow",
  "VirtualRun",
  "Walk",
  "Wheelchair",
  "Windsurf",
]);
